import { render, staticRenderFns } from "./BoTopic.vue?vue&type=template&id=4d010c40&"
import script from "./BoTopic.vue?vue&type=script&lang=js&"
export * from "./BoTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports